import { Box, Typography } from '@mui/material';
import parse from 'html-react-parser';
import { FunctionComponent } from 'react';

import EmailFileAttachment from '@Containers/Emails/EmailFileAttachment';

import { ImageBox } from './EmailPreview.styles';
import { EmailPreviewProps } from './EmailPreview.types';

const EmailPreview: FunctionComponent<EmailPreviewProps> = (
  props: EmailPreviewProps
): JSX.Element => {
  const { data } = props;

  const { header, footer, listOfAttachments, subject, message } = data;

  /** Parses incoming string message and converting it to Html */
  const htmlMessage = parse(message);

  return (
    <Box>
      <Typography sx={{ mb: 2.4 }} variant="h2">
        {subject}
      </Typography>
      {!!header.data.length && (
        <ImageBox>
          <img src={header.data[0].url} alt="email_header_img" />
        </ImageBox>
      )}
      <Box mb={2.4}>{htmlMessage}</Box>
      {!!footer.data.length && (
        <ImageBox>
          <img src={footer.data[0].url} alt="email_header_img" />
        </ImageBox>
      )}
      <Box mb={2.4}>
        {!!listOfAttachments.data?.length && (
          <EmailFileAttachment
            attachments={listOfAttachments.data}
            viewOnly
            uploadBtnText="hello"
            uploadBtnIcon="attachment"
            acceptedFormat="image/*"
            isPreview
          />
        )}
      </Box>
    </Box>
  );
};

export default EmailPreview;
